// ink-component
import React, { ReactNode } from 'react';
import globalProps from '../../../helpers/constants/global-props';

import BreadcrumbItemElement from './BreadcrumbItemElement';

export interface BreadcrumbElementProps extends React.HTMLAttributes<HTMLElement> {
  /** Render prop callback */
  render?: (props: any) => ReactNode;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
}

/**
 * @purpose An item inside a Breadcrumb
 * @group Breadcrumb
 * @categories navigation
 * @HTMLType HTMLSpanElement
 */
function BreadcrumbElement(props: BreadcrumbElementProps) {
  const { render, style, ...otherProps } = props;

  return (
    <BreadcrumbItemElement
      {...globalProps}
      {...otherProps}
      render={props.render && props.render(otherProps)}
      as={!render ? 'span' : undefined}
    />
  );
}

BreadcrumbElement.defaultProps = {
  render: undefined,
  'data-testid': undefined,
};

BreadcrumbElement.displayName = 'Breadcrumb.Element';

export default BreadcrumbElement;
